import {IController, IModule, IOnChangesObject} from "angular";
import moment from "moment";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Debugger} from "debug";
import {Tidssonevalg} from "felles/tjenester/i18n/Tidssonevalg";
import _ from "lodash";

import {tz} from "moment-timezone" //uten denne kompilerer ikke uttrykket moment.tz
require('moment-timezone');//utvider moment

const debuger = require('debug');
const debug:Debugger = debuger('TidssonesøkKontroller');

const css = require('./tidssonesøk.scss');

export class TidssonesøkKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkTidssonesoek', {
                bindings: {gjeldendeTidssone: '<?', vedValg: '&', tidssoner: '<'},
                controller: TidssonesøkKontroller.forInjisering(),
                template: require('./tidssonesøk.html')
            });
    }

    static forInjisering() {
        return [TidssonesøkKontroller]
    }

    constructor() {
        if (!this.gjeldendeTidssone) {
           this.tidssone = moment.tz.guess();
        }
        else this.tidssone = this.gjeldendeTidssone;
    }

    tidssoner :string[]; //settes via bindings/$onChanges
    gjeldendeTidssone: string; //settes via bindings/$onChanges
    vedValg: (arg: { tidssone: string; }) => any; //settes via bindings/$onChanges

    // offentlig for template
    tidssone: string = null;
    sokestreng: string;

    velgSone(tidssone) {
        this.gjeldendeTidssone = tidssone;
        this.vedValg({tidssone: tidssone});
    }

    soek(søkestreng: string) {
        const streng = søkestreng.replace(' ', '_');
        const søk = new RegExp(streng, "gi");
        return this.tidssoner
            .filter((sone) => sone.match(søk) && sone.match(søk).length > 0)
            .map(this.mapTidssoneMedVisning);
    }

    mapTidssoneMedVisning(treff) {
        return {
            visning: Tidssonevalg.tidssoneFormatert(treff),
            verdi: treff
        }
    }

    $onChanges(changes: IOnChangesObject): void {
        if (changesInneholder(changes, 'gjeldendeTidssone')){
            this.sokestreng = Tidssonevalg.tidssoneFormatert(this.gjeldendeTidssone);
        }
    }
}
